<div class='flex items-center justify-center avatar relative' [ngClass]="'avatar__size--' + size">
  <div *ngIf="editMode" class="w-full flex flex-col items-center justify-center center absolute z-10 cursor-pointer">
    <mat-icon svgIcon="camera" color="primary" class="mat-icon-l"></mat-icon>
    <span class="link text-center mt-1">{{'avatar.' + (!logo ? 'addImage' : 'changeImage') | translate }}</span>
  </div>
  <span *ngIf="text && !logo" [ngClass]="{'img-opacity': editMode}" class="uppercase">{{Helper.getInitials(text)}}</span>
  <img *ngIf="logo" ngSrc="{{logo}}" fill [alt]="text" [ngClass]="{'img-opacity': editMode}" class="avatar__img w-full h-full object-cover block"/>
</div>
